import { Box, Button, Form } from '@factorialco/deprecated-design-system'

import TextArea from 'modules/core/components/TextArea'
import { useForm } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

export interface Props {
  onFormSubmit: (data: FeedbackFormValues) => Promise<void>
  onFormDismiss: () => Promise<void>
}

export interface FeedbackFormValues {
  comment?: string | undefined
}

const FeedbackForm = ({ onFormSubmit, onFormDismiss }: Props) => {
  const form = useForm<FeedbackFormValues>({
    defaultValues: {},
    onSubmit: async (values) => {
      await onFormSubmit({ comment: values.comment })

      return { success: true, data: { comment: values.comment } }
    },
  })

  return (
    <Box paddingTop="s16">
      <Form onSubmit={form.handleSubmit} padding="s0">
        <TextArea
          label={undefined}
          placeholder={i18n.t('common.feedback.form.placeholder')}
          value={form.values.comment || undefined}
          onChange={(comment) => form.setValues({ ...form.values, comment: comment })}
        />
        <Box paddingTop="s16" justifyContent="flexEnd" flexDirection="row" gap="s8">
          <Button type="secondary" onClick={onFormDismiss}>
            {i18n.t('common.feedback.form.dismiss')}
          </Button>
          <Button
            type="primary"
            onClick={() => {
              form.handleSubmit()
            }}
          >
            {i18n.t('common.feedback.form.submit')}
          </Button>
        </Box>
      </Form>
    </Box>
  )
}

export default FeedbackForm
